// extracted by mini-css-extract-plugin
export default {"aText":"About_aText__eor-c","blurb":"About_blurb__IL66S","meImg":"About_meImg__iI3s9","resLink":"About_resLink__+V1Jj","right":"About_right__v6Aac"};